import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useLegalLinksContext } from '@context/LegalLinksContext'

import { Link } from '@ui/components/Link'

import { TickmillProductType } from '@model/TickmillProductType'

import { useLinksConfig } from '@hooks/useLinksConfig'

type RiskAcceptanceSection = {
  text?: string
  list?: string[]
}

interface Props {
  product: TickmillProductType
}
export const ApTestRiskText: React.FC<Props> = ({ product }) => {
  const { docLinks } = useLegalLinksContext()
  const { t } = useTranslation()
  const { links } = useLinksConfig()

  const message = t('SQF.riskAcceptance.message', {
    returnObjects: true,
  }) as RiskAcceptanceSection[]
  const riskDisclosureLink = (
    <Link
      href={docLinks?.riskDisclosure ?? links.footer.TICKMILL_EU.riskDisclosure}
      target='_blank'
      size='lg'
      rel='noopener noreferrer'
    />
  )

  const renderTrans = (i18nKey: string) => (
    <Trans
      i18nKey={i18nKey}
      components={{
        a: riskDisclosureLink,
      }}
    />
  )

  if (product === TickmillProductType.SQF) {
    return (
      <>
        {message.map((line, lineIndex) => (
          <React.Fragment key={`${line.text ?? 'section'}-${lineIndex}`}>
            {line.text && renderTrans(line.text)}
            {line.list?.map((item) => (
              <React.Fragment key={item}>
                <br />- {renderTrans(item)}
              </React.Fragment>
            ))}
            {lineIndex < message.length - 1 && (
              <>
                <br />
                <br />
              </>
            )}
          </React.Fragment>
        ))}
      </>
    )
  }

  return (
    <Trans
      i18nKey='Sign up.Marginally pass message'
      components={{
        a: riskDisclosureLink,
      }}
    />
  )
}
